import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

const HeaderNavAction = forwardRef(
  ({ surface, className, children, active, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={classNames(
          'HeaderNavAction',
          'nav-link',
          `HeaderNavAction--${surface}`,
          className,
          { active }
        )}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

HeaderNavAction.displayName = 'HeaderNavAction';

HeaderNavAction.propTypes = {
  surface: PropTypes.oneOf(['top', 'bottom']).isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  active: PropTypes.bool,
};

HeaderNavAction.defaultProps = {
  className: '',
  children: null,
  active: false,
};

export default HeaderNavAction;
